import React from 'react';

import classNames from 'clsx';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { FormattedCurrency } from '../../components/formatted-currency';
import { LabelWithValue } from './label-with-value';
import { messages } from './messages';
import style from './style.module.less';

export const PackageDetails = ({ pack }) => {
  const { dimensions, weight, items, insuredValue, packageCode } = pack;
  const insuredValueText = insuredValue ? <FormattedCurrency currencyCode={insuredValue.currency} value={insuredValue.amount} /> : '--';
  return (
    <>
      <div className={style.header}>
        <FormattedMessage {...messages.packageDetailsHeader} />
      </div>
      <div className={classNames(style['package-details'], style.underline)}>
        <div>
          <LabelWithValue label={<FormattedMessage {...messages.insuredValueLabel} />} value={insuredValueText} />
        </div>
        <div>
          <LabelWithValue label={<FormattedMessage {...messages.packageCode} />} value={packageCode ?? '--'} />
        </div>
        <div className={style['package-information']}>
          <div>
            <LabelWithValue
              label={<FormattedMessage {...messages.dimensions} />}
              value={`${dimensions?.length ?? '--'} X ${dimensions?.width ?? '--'} X ${dimensions?.height ?? '--'}`}
            />
          </div>
          <div>
            <LabelWithValue label={<FormattedMessage {...messages.weight} />} value={weight?.value ?? '--'} />
          </div>
        </div>
      </div>
      <div className={style.label}>
        <FormattedMessage {...messages.itemsHeader} />
      </div>
      {items?.length > 0
        ? items.map(({ sku }) => (
            <div key={sku} className={style.value}>
              {sku}
            </div>
          ))
        : '--'}
    </>
  );
};

PackageDetails.propTypes = {
  pack: PropTypes.shape({
    packageCode: PropTypes.string,
    insuredValue: PropTypes.shape({
      amount: PropTypes.number,
      currency: PropTypes.string,
    }),
    dimensions: PropTypes.shape({
      length: PropTypes.number,
      width: PropTypes.number,
      height: PropTypes.number,
    }),
    weight: PropTypes.shape({
      value: PropTypes.number,
    }),
    items: PropTypes.arrayOf(
      PropTypes.shape({
        sku: PropTypes.string,
      }),
    ),
  }).isRequired,
};
